import React from 'react';
import MaskedInput from 'react-maskedinput';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

function renderMaskedInput(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask="111.111.111-11"
      placeholderChar="_"
    />
  );
}

function CPFField({ InputLabelProps, ...other }) {
  return (
    <TextField
      {...other}
      InputLabelProps={InputLabelProps}
      InputProps={{
        inputComponent: renderMaskedInput,
      }}
    />
  );
}

CPFField.propTypes = {
  InputLabelProps: PropTypes.object,
};

CPFField.defaultProps = {
  InputLabelProps: { shrink: false },
};

export default CPFField;
